var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssessmentUltrasound = function SvgAssessmentUltrasound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343754",
    fillRule: "evenodd",
    d: "M29.242 10l-1.14 1.086A5.909 5.909 0 0 1 24 12.706c-1.551 0-3.008-.574-4.103-1.62L18.757 10 0 27.885l1.139 1.086C7.243 34.793 15.364 38 24 38c8.634 0 16.753-3.207 22.86-9.03L48 27.886 29.242 10zM24 34.926c-7.236 0-14.069-2.5-19.41-7.07l7.88-7.516c3.232 2.58 7.265 3.992 11.53 3.992v-3.074c-3.404 0-6.628-1.095-9.241-3.1l4.1-3.908A9.257 9.257 0 0 0 24 15.78a9.266 9.266 0 0 0 5.142-1.53l9.818 9.363c-4.153 3.446-9.399 5.346-14.96 5.346v3.074c6.424 0 12.49-2.205 17.258-6.231l2.152 2.054c-5.343 4.57-12.176 7.07-19.41 7.07z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssessmentUltrasound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assessment-ultrasound.72ec389c.svg";
export { ForwardRef as ReactComponent };